import script from "./CertificateValidationQr.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateValidationQr.vue?vue&type=script&setup=true&lang=js"

import "./CertificateValidationQr.vue?vue&type=style&index=0&id=450d37cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450d37cc"]])

export default __exports__